import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'

export interface ReturnCollection {
  id: number
  collectionNo: string
  parentComposedCollectionId: number
  bibliographyId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SystemCode
  displayTitle: string
  displayAuthor: string
  collectionStatus: SystemCode
  appendixCode: SystemCode
  dueDate: string
  holdingBranchCode: SystemCode
  forwardingBranchCode: SystemCode
  shelfType: SystemCode
  handlingType: SystemCode
  callNo: string
  lendTotal: number
  lendRemaining: number
  reservedId: number
  reservedUserId: string
  reservedUserName: string
  lendUserId: string
  lendUserName: string
  workMemo: string
  displayMemo: string
  localMemo: string
  collectionFlag: CollectionFlag
  revision: number
  receiptInfoReserve: any // 可変値のためanyとする
  receiptInfoReserveForwarding: any // 可変値のためanyとする
  receiptInfoShelf: any // 可変値のためanyとする
  receiptInfoReturnConfirm: any // 可変値のためanyとする
  receiptInfoInterlibraryLoanBorrowReturnConfirm: any // 可変値のためanyとする
  receiptInfoMemo: any // 可変値のためanyとする
  inputHandlingType: string // レスポンスで返却されているわけではないが、別apiで使用したいので設定
  inputShelfType: string // レスポンスで返却されているわけではないが、別apiで使用したいので設定
  _deleteHandlingType: boolean // レスポンスで返却されているわけではないが、別apiで使用したいので設定
  appendixLendFlag: boolean
}

export function ReturnCollectionFromJSON(json: any): ReturnCollection {
  return {
    id: exists(json, 'id') ? json.id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    parentComposedCollectionId: exists(json, 'parent_composed_collection_id')
      ? json.parent_composed_collection_id
      : 0,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Set,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    collectionStatus: exists(json, 'collection_status')
      ? SystemCodeFromJSON(json.collection_status)
      : defaultSystemCode(),
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    dueDate: exists(json, 'due_date') ? dateToPlainFormat(json.due_date) : '',
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    forwardingBranchCode: exists(json, 'forwarding_branch_code')
      ? SystemCodeFromJSON(json.forwarding_branch_code)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    callNo: exists(json, 'call_no') ? json.call_no : '',
    lendTotal: exists(json, 'lend_total') ? json.lend_total : 0,
    lendRemaining: exists(json, 'lend_remaining') ? json.lend_remaining : 0,
    reservedUserId: exists(json, 'reserved_user_id')
      ? json.reserved_user_id
      : '',
    reservedUserName: exists(json, 'reserved_user_name')
      ? json.reserved_user_name
      : '',
    reservedId: exists(json, 'reserved_id') ? json.reserved_id : 0,
    lendUserId: exists(json, 'lend_user_id') ? json.lend_user_id : '',
    lendUserName: exists(json, 'lend_user_name') ? json.lend_user_name : '',
    workMemo: exists(json, 'work_memo') ? json.work_memo : '',
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    localMemo: exists(json, 'local_memo') ? json.local_memo : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    revision: exists(json, 'revision') ? json.revision : 0,
    receiptInfoReserve: exists(json, 'receipt_info_reserve')
      ? json.receipt_info_reserve
      : undefined,
    receiptInfoReserveForwarding: exists(
      json,
      'receipt_info_reserve_forwarding'
    )
      ? json.receipt_info_reserve_forwarding
      : undefined,
    receiptInfoShelf: exists(json, 'receipt_info_shelf')
      ? json.receipt_info_shelf
      : undefined,
    receiptInfoReturnConfirm: exists(json, 'receipt_info_return_confirm')
      ? json.receipt_info_return_confirm
      : undefined,
    receiptInfoInterlibraryLoanBorrowReturnConfirm: exists(
      json,
      'receipt_info_interlibrary_loan_borrow_return_confirm'
    )
      ? json.receipt_info_interlibrary_loan_borrow_return_confirm
      : undefined,
    receiptInfoMemo: exists(json, 'receipt_info_memo')
      ? json.receipt_info_memo
      : undefined,
    inputHandlingType: '',
    inputShelfType: '',
    _deleteHandlingType: false,
    appendixLendFlag: exists(json, 'appendix_lend_flag')
      ? json.appendix_lend_flag
      : undefined
  }
}
